"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var RawExampleLayout_1 = require("./RawExampleLayout");
var ContentExampleLayout_1 = require("./ContentExampleLayout");
var PropertiesLayout_1 = require("./PropertiesLayout");
exports.ComponentLayoutPage = function () { return (React.createElement(common_1.Page, { headerText: "Layout" },
    React.createElement(common_1.Paragraph, null, "Layout has an AppBar, Drawer and LayoutBody built-in, ready to use. It's nice if you want to layout an app fast."),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(RawExampleLayout_1.RawExampleLayout, null),
    React.createElement(ContentExampleLayout_1.ContentExampleLayout, null),
    React.createElement(common_1.TopicHeader, null, "Properties"),
    React.createElement(PropertiesLayout_1.PropertiesLayout, null))); };
exports.ComponentLayoutPage.displayName = 'ComponentLayoutPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentLayoutPage/ComponentLayoutPage.tsx
// module id = 689
// module chunks = 0